import axios from "axios";
import { getBaseURLforBackEnd  , getConfigAxios } from '@/utils.js'
import master_data from "./master_data";


export default {
    namespaced: true,
    state: {
        // groupNonautomateRequest :[],
        // detailEachGroup :[],
        patho_items : [],
        firstPathoItems : 100,
        skipPathoItems : 0,
        //
        firstTimeStart  : true,
        //
        searchFor : "",
    },

    getters: {
    },

    mutations: {


        setPatho_items(state,patho_items){
            state.patho_items = patho_items
        },

        setPatho_itemsConcat(state,data){
            state.patho_items = state.patho_items.concat(data)
        },




        setFirstPathoItems(state,firstPathoItems){
            state.firstPathoItems = firstPathoItems
        },


        setSkipPathoItems(state,skipPathoItems){
            state.skipPathoItems = skipPathoItems
        },
        
        setFirstTimeStart(state,firstTimeStart){
            state.firstTimeStart = firstTimeStart
        }, 

        setSearchFor(state,searchFor){
            state.searchFor = searchFor
        },  
         
         

    },

    actions: {
      



        fetchSearchItemsPatho({commit,state},payload){
            // payload
            // {
            //     "search_txt" : "",
            //     "admin" : true/false, 
            // }
         
            const datTo =   {
                            "first" : state.firstPathoItems,
                            "skip" : state.skipPathoItems ,
                            "search_txt" : payload.search_txt,
                            "admin" : payload.admin,
                            "seeall_mode": payload.seeall_mode //  
                        }
              
            return new Promise((resolve,reject) => {
                axios.defaults.headers.common['Authorization'] = `Bearer  ${master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/listofpartpatho`,datTo,getConfigAxios())
                    .then((res)=>{
                        // console.log('res.data-->',res.data)
                        // reset
                      
                        // result set
                        if(payload.loadmore){
                            commit('setPatho_itemsConcat',res.data)

                            // console.log("setPatho_itemsConcat")     
                        }else{
                            if(res.data.length === 0){
                                commit('setPatho_items',[])  
                            }else{
                                commit('setPatho_items',res.data)
                            }
                           

                            // console.log("setPatho_items")   
                        }
                         
                        //
                        commit('setSearchFor',payload.search_txt) 



                        resolve(res.data)
                    })
                    .catch(err =>{
                        commit('setPatho_items',[])  
                        reject(err)
                    })
            })
        } ,



         


        
       


    }
}